export default {
    getInviteLink: getInviteLink
}

function getInviteLink(invitation, strings) {
    var inviteLink = '';
    var inviteType = invitation.replace('_', ' ').toUpperCase();
    switch(inviteType) {
        case 'PRIMARY DISTRIBUTOR':
            invitationLink = strings.get('tdc_distributorInvitationMessage');
            break;
        case 'AGENT':
            invitationLink = strings.get('tdc_agentInvitationMessage');
            break;
        case 'RETAILER':
            invitationLink = strings.get('tdc_retailerInvitationMessage');
            break;
        case 'PREFERRED CUSTOMER':
            invitationLink = strings.get('tdc_preferredInvitationMessage');
            break;
        case 'RETAIL CUSTOMER':
            invitationLink = strings.get('tdc_retailInvitationMessage');
            break;
    }
    return inviteLink;
}
